"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDashboardDropZone = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_grid_system_1 = require("react-grid-system");
var useDashboardDrop_1 = require("../useDashboardDrop");
var types_1 = require("../types");
var model_1 = require("../../../model");
var dashboardContexts_1 = require("../../dashboardContexts");
var useNewSectionInsightListItemDropHandler_1 = require("./useNewSectionInsightListItemDropHandler");
var useNewSectionKpiPlaceholderDropHandler_1 = require("./useNewSectionKpiPlaceholderDropHandler");
var useNewSectionInsightPlaceholderDropHandler_1 = require("./useNewSectionInsightPlaceholderDropHandler");
var sizing_1 = require("../../../_staging/layout/sizing");
var widgetCategoryMapping = {
    "insight-placeholder": "insight",
    insightListItem: "visualization",
    "kpi-placeholder": "kpi",
};
exports.EmptyDashboardDropZone = function () {
    var _a;
    var _b;
    var dispatch = model_1.useDashboardDispatch();
    var widgetPlaceholder = model_1.useDashboardSelector(model_1.selectWidgetPlaceholder);
    var EmptyLayoutDropZoneBodyComponent = dashboardContexts_1.useDashboardComponentsContext().EmptyLayoutDropZoneBodyComponent;
    var handleInsightListItemDrop = useNewSectionInsightListItemDropHandler_1.useNewSectionInsightListItemDropHandler(0);
    var handleKpiPlaceholderDrop = useNewSectionKpiPlaceholderDropHandler_1.useNewSectionKpiPlaceholderDropHandler(0);
    var handleInsightPlaceholderDrop = useNewSectionInsightPlaceholderDropHandler_1.useNewSectionInsightPlaceholderDropHandler(0);
    var _c = tslib_1.__read(useDashboardDrop_1.useDashboardDrop(["insightListItem", "kpi-placeholder", "insight-placeholder"], {
        drop: function (item) {
            if (types_1.isInsightDraggableListItem(item)) {
                handleInsightListItemDrop(item.insight);
            }
            if (types_1.isKpiPlaceholderDraggableItem(item)) {
                handleKpiPlaceholderDrop();
            }
            if (types_1.isInsightPlaceholderDraggableItem(item)) {
                handleInsightPlaceholderDrop();
            }
        },
    }, [
        dispatch,
        widgetPlaceholder,
        handleInsightListItemDrop,
        handleKpiPlaceholderDrop,
        handleInsightPlaceholderDrop,
    ]), 2), _d = _c[0], canDrop = _d.canDrop, isOver = _d.isOver, itemType = _d.itemType, item = _d.item, dropRef = _c[1];
    var _e = ((_b = item) === null || _b === void 0 ? void 0 : _b.size) || {}, _f = _e.gridWidth, gridWidth = _f === void 0 ? 12 : _f, gridHeight = _e.gridHeight;
    var message = react_1.default.createElement(react_intl_1.FormattedMessage, { id: "newDashboard.dropInsight" });
    var widgetCategory = widgetCategoryMapping[itemType];
    return (react_1.default.createElement(react_grid_system_1.Col, { xl: gridWidth, lg: gridWidth, md: gridWidth, sm: gridWidth, xs: gridWidth, style: {
            minHeight: gridHeight ? sizing_1.getDashboardLayoutItemHeightForGrid(gridHeight) : undefined,
        }, className: classnames_1.default("drag-info-placeholder", "dash-item", (_a = {},
            _a["type-" + widgetCategory] = !!widgetCategory,
            _a["type-none"] = !widgetCategory,
            _a["s-last-drop-position"] = canDrop,
            _a)) },
        react_1.default.createElement("div", { className: classnames_1.default("drag-info-placeholder-inner", { "can-drop": canDrop, "is-over": isOver }), ref: dropRef },
            react_1.default.createElement(EmptyLayoutDropZoneBodyComponent, null),
            react_1.default.createElement("div", { className: "drag-info-placeholder-drop-target s-drag-info-placeholder-drop-target" },
                react_1.default.createElement("div", { className: "drop-target-inner" },
                    react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p", className: "drop-target-message kpi-drop-target" }, message),
                    react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p", className: "drop-target-message visualization-drop-target" }, message))))));
};
//# sourceMappingURL=EmptyDashboardDropZone.js.map